module.exports = __webpack_public_path__ + "assets/83eef692cd1e01b10d8bd1bea5a18a0c.png";